import React from 'react';
import { Card } from 'material-ui/Card';
import { FlatButton, CardText, CardTitle } from 'material-ui';
import { translate as t } from 'admin-on-rest';

export default t((props) => (
  <Card>
    <CardTitle title={props.translate('globalSettings')} />
    {props.user && props.user.superUser && ([
      <CardText>
        {props.translate('globalPspCaption')}
      </CardText>,
      <CardText>
        <a href="#/psps"><FlatButton primary label={props.translate('resources.psps.name', { smart_count: 1 })} /></a>
      </CardText>,
    ])}
  </Card>
));
